import { createAuthClient } from "better-auth/client";
import { emailOTPClient, magicLinkClient } from "better-auth/client/plugins";
import { readFileSync, existsSync } from "node:fs";
import { join } from "node:path";
import { homedir } from "os";
import { getBaseUrl } from "@/config";

// Define the path to our auth file
const AUTH_FILE = join(homedir(), ".beeps", "auth.json");

// Function to get the token from our file-based store
const getTokenFromFile = (): string => {
  if (!existsSync(AUTH_FILE)) {
    return "";
  }

  try {
    const data = JSON.parse(readFileSync(AUTH_FILE, "utf-8"));
    return data.token || "";
  } catch (error) {
    console.error("Failed to read auth token from file:", error);
    return "";
  }
};

// Create a CLI-specific auth client
// Using Record<string, any> to avoid type inference issues with nanostores
export const cliAuthClient: Record<string, any> = createAuthClient({
  baseURL: getBaseUrl({ prodUrl: !process.env.BEEPS_DEVELOPMENT }),
  plugins: [emailOTPClient(), magicLinkClient()],
  fetchOptions: {
    auth: {
      type: "Bearer",
      token: getTokenFromFile, // Use our custom function to get the token
    },
  },
});
